document.addEventListener('DOMContentLoaded', function() {
    const propertyElements = document.querySelectorAll('.product-option dd');

    propertyElements.forEach(function(element) {
        let content = element.innerHTML.trim();

        // Create a textarea for all properties
        const textarea = document.createElement('textarea');
        textarea.style.width = '100%'; // Full width
        textarea.style.height = '110px'; // Fixed height
        textarea.style.resize = 'none'; // Prevent manual resizing
        textarea.readOnly = true; // Make the textarea read-only
        textarea.style.overflow = 'hidden'; // Hide overflow

        // Replace HTML entities and remove <mark> tags
        textarea.textContent = content.replace(/<\/?mark>/g, '').replace(/&lt;/g, '<').replace(/&gt;/g, '>');

        // Disable text selection and copying
        textarea.addEventListener('copy', function(event) {
            event.preventDefault(); // Prevent copying
        });

        // Clear original content and append textarea
        element.innerHTML = ''; 
        element.appendChild(textarea);
    });
});